import { atom } from 'jotai'
import { atomFamily } from 'jotai-family'

export type FloatingActivityKind = 'rfq'
export type FloatingActivityTone = 'active' | 'warning'

export interface FloatingActivityRailItem {
  id: string
  kind: FloatingActivityKind
  label: string
  count?: number
  tone: FloatingActivityTone
}

export const floatingActivityRailItemsAtom = atom<FloatingActivityRailItem[]>([])

export const floatingActivityMinimizedAtomFamily = atomFamily((id: string) =>
  atom((get) => get(floatingActivityRailItemsAtom).some((item) => item.id === id))
)

export const upsertFloatingActivityRailItemAtom = atom(
  null,
  (get, set, item: FloatingActivityRailItem) => {
    const current = get(floatingActivityRailItemsAtom)
    const index = current.findIndex((entry) => entry.id === item.id)
    if (index === -1) {
      set(floatingActivityRailItemsAtom, [...current, item])
      return
    }
    if (
      current[index].kind === item.kind &&
      current[index].label === item.label &&
      current[index].count === item.count &&
      current[index].tone === item.tone
    ) {
      return
    }
    const next = [...current]
    next[index] = item
    set(floatingActivityRailItemsAtom, next)
  }
)

export const removeFloatingActivityRailItemAtom = atom(null, (get, set, id: string) => {
  const current = get(floatingActivityRailItemsAtom)
  const next = current.filter((item) => item.id !== id)
  if (next.length !== current.length) set(floatingActivityRailItemsAtom, next)
})
